/*
  Koala Pets — sticky cart button
  Opens the native Dawn cart drawer and mirrors the header cart count.
  Framework-free and defensive. (Cart upsell/discount were removed to keep the
  drawer simple and match Dawn's proven layout.)
*/
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function setCount(sticky, countEl, n) {
    countEl.textContent = n;
    sticky.classList.toggle('is-empty', !n);
  }

  function updateStickyCount() {
    var sticky = document.querySelector('[data-koala-sticky-cart]');
    if (!sticky) return;
    var countEl = sticky.querySelector('[data-koala-sticky-count]');
    if (!countEl) return;

    // Prefer the header bubble (Dawn keeps it in sync); fall back to /cart.js
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
    if (bubble) {
      var n = parseInt(bubble.textContent.trim(), 10);
      if (!isNaN(n)) { setCount(sticky, countEl, n); return; }
    }
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(sticky, countEl, c.item_count); })
      .catch(function () {});
  }

  // Open the drawer (or fall back to the cart page)
  document.addEventListener('click', function (e) {
    var sticky = e.target.closest('[data-koala-sticky-cart]');
    if (!sticky) return;
    e.preventDefault();
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); }
    else { window.location.href = root + 'cart'; }
  });

  // Keep the count in sync with the header cart bubble
  function observeBubble() {
    var bubble = document.querySelector('#cart-icon-bubble');
    if (!bubble || !window.MutationObserver) return;
    new MutationObserver(updateStickyCount).observe(bubble, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState !== 'loading') { observeBubble(); updateStickyCount(); }
  else { document.addEventListener('DOMContentLoaded', function () { observeBubble(); updateStickyCount(); }); }

  // Rabbit Ears 2kg upsell: one-click variant swap in the cart drawer
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.koala-upsell__btn');
    if (!btn || btn.dataset.busy) return;
    e.preventDefault();
    btn.dataset.busy = '1';
    btn.disabled = true;
    var lineKey = btn.getAttribute('data-upsell-line');
    var vid = parseInt(btn.getAttribute('data-upsell-variant'), 10);
    var qty = parseInt(btn.getAttribute('data-upsell-qty'), 10) || 1;
    var post = function (url, body) {
      return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    };
    post('cart/change.js', { id: lineKey, quantity: 0 })
      .then(function () { return post('cart/add.js', { items: [{ id: vid, quantity: qty }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname }); })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var secs = (data && data.sections) || {};
        if (secs['cart-drawer']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = secs['cart-drawer'];
          var fresh = tmp.querySelector('#CartDrawer');
          var cur = document.querySelector('#CartDrawer');
          if (fresh && cur) { cur.innerHTML = fresh.innerHTML; }
          else { window.location.href = root + 'cart'; return; }
        } else { window.location.href = root + 'cart'; return; }
        if (secs['cart-icon-bubble']) {
          var b = document.querySelector('#cart-icon-bubble');
          if (b) b.innerHTML = secs['cart-icon-bubble'];
        }
        updateStickyCount();
      })
      .catch(function () { window.location.href = root + 'cart'; });
  });

  // ---- Added-line flash --------------------------------------------------
  // Capture variants added to the cart (any add-to-basket on the site), then
  // briefly highlight the matching line when the drawer re-renders.
  var koalaRecentAdds = {}; // variantId -> timestamp

  function noteAdded(ids) {
    var now = Date.now();
    (ids || []).forEach(function (id) { if (id) koalaRecentAdds[String(id)] = now; });
  }

  function parseAddBody(body) {
    try {
      if (typeof body === 'string') {
        if (body.charAt(0) === '{') {
          var j = JSON.parse(body);
          if (j.items) return j.items.map(function (i) { return i.id; });
          if (j.id) return [j.id];
        } else {
          // urlencoded form (Dawn default add)
          var p = new URLSearchParams(body);
          if (p.get('id')) return [p.get('id')];
        }
      }
    } catch (e) {}
    return [];
  }

  // Wrap fetch so we see every cart/add.js call, wherever it comes from.
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (url.indexOf('/cart/add') !== -1 && init && init.body) {
          noteAdded(parseAddBody(init.body));
        }
      } catch (e) {}
      return origFetch.apply(this, arguments);
    };
  }

  function flashRecentLines(root) {
    var scope = root || document;
    var now = Date.now();
    Object.keys(koalaRecentAdds).forEach(function (id) {
      if (now - koalaRecentAdds[id] > 5000) { delete koalaRecentAdds[id]; return; }
      var input = scope.querySelector('[data-quantity-variant-id="' + id + '"]');
      var row = input && input.closest('tr.cart-item');
      if (row && !row.dataset.koalaFlashed) {
        row.dataset.koalaFlashed = '1';
        row.classList.add('koala-line-flash');
        setTimeout(function () { row.classList.remove('koala-line-flash'); delete row.dataset.koalaFlashed; }, 1600);
      }
    });
  }

  // Inject the flash animation once.
  (function injectFlashCSS() {
    if (document.getElementById('koala-flash-css')) return;
    var s = document.createElement('style');
    s.id = 'koala-flash-css';
    s.textContent = '@keyframes koalaLineFlash{0%{background:rgba(74,138,32,.18)}100%{background:transparent}}'
      + '#CartDrawer tr.koala-line-flash,#main-cart-items tr.koala-line-flash{animation:koalaLineFlash 1.6s ease-out;border-radius:8px;}';
    document.head.appendChild(s);
  })();

  // Watch the drawer for re-renders and flash newly added lines.
  function watchDrawerForFlash() {
    var drawer = document.querySelector('#CartDrawer');
    if (!drawer || !window.MutationObserver) return;
    new MutationObserver(function () { flashRecentLines(drawer); }).observe(drawer, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') { watchDrawerForFlash(); }
  else { document.addEventListener('DOMContentLoaded', watchDrawerForFlash); }

  // "Add to your order" drawer upsell: add in place with a hidden _upsell property
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.kud-add');
    if (!btn || btn.dataset.busy) return;
    e.preventDefault();
    btn.dataset.busy = '1';
    btn.disabled = true; btn.textContent = 'Adding…';
    var vid = parseInt(btn.getAttribute('data-kud-variant'), 10);
    noteAdded([vid]);
    var onCartPage = !!document.getElementById('main-cart-items');
    fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1, properties: { _upsell: 'drawer' } }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (onCartPage) { window.location.reload(); return; }
        var secs = (data && data.sections) || {};
        if (secs['cart-drawer']) {
          var tmp = document.createElement('div'); tmp.innerHTML = secs['cart-drawer'];
          var fresh = tmp.querySelector('#CartDrawer'); var cur = document.querySelector('#CartDrawer');
          if (fresh && cur) { cur.innerHTML = fresh.innerHTML; }
        }
        if (secs['cart-icon-bubble']) { var b = document.querySelector('#cart-icon-bubble'); if (b) b.innerHTML = secs['cart-icon-bubble']; }
        var d = document.querySelector('cart-drawer'); if (d) { d.classList.remove('is-empty'); }
        updateStickyCount();
      })
      .catch(function () { window.location.href = root + 'cart'; });
  });
})();
